<script>
  import { slide } from "svelte/transition";
  export let title = "Title";
  export let css = "";
  let display = false;
  function accordionToggle(e) {
    display = !display;
     
  }
  let uid = Math.random().toString(36).substring(2);
</script>

<div
  class="{css}"
  data-target={uid}
  on:click={accordionToggle}>
  {@html title}
</div>
{#if display}
<div 
transition:slide class="bg-white w-full rounded-b px-3 py-2 border " id={uid}>
  <slot />
</div>
{/if}